var render, staticRenderFns
import script from "./detailUpdateBefore.vue?vue&type=script&lang=js"
export * from "./detailUpdateBefore.vue?vue&type=script&lang=js"
import style0 from "./detailUpdateBefore.vue?vue&type=style&index=0&id=1d1e243f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1e243f",
  null
  
)

export default component.exports